import type { PlanHuntMember } from './types'

const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? ''

/**
 * Stable people ordering for the plan-hunt person lists: the hunt's creator is
 * pinned first (regardless of name), everyone else is sorted alphabetically by
 * first name (case-insensitive), with the full name as a deterministic
 * tie-break. Pure and selection-independent, so the order never reshuffles.
 */
export function orderPlanHuntMembers(members: PlanHuntMember[], creatorId?: string): PlanHuntMember[] {
  return [...members].sort((a, b) => {
    if (creatorId) {
      if (a.id === creatorId) return -1
      if (b.id === creatorId) return 1
    }
    const byFirst = firstName(a.name).toLowerCase().localeCompare(firstName(b.name).toLowerCase())
    return byFirst !== 0 ? byFirst : a.name.localeCompare(b.name)
  })
}
